// extracted by mini-css-extract-plugin
module.exports = {"nounProfileInfo":"Profile_nounProfileInfo__2SvQO","nounProfileWrapper":"Profile_nounProfileWrapper__1A1UK"};